@if (authorized ) {
  <app-dashboard></app-dashboard>
} @else {
  <app-logout></app-logout>
}
